import * as React from "react";

import { useFrontpage } from "../../../common/FrontpageProvider";
import NoteView from "../../../common/components/NoteView";

const HomePage: React.FC<{}> = ({}) => {
  const {state, setCurrentNote} = useFrontpage();

  React.useEffect(() => {
    setCurrentNote(null);
  }, []);

  const {initialNote} = state.serverState;

  return <div>
    {initialNote && <NoteView note={initialNote}/>}
  </div>
}

export default HomePage;